import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EventDto } from '@core/models/planner-models/event.dto';
import { PlanerCalendarSearchDto } from '@core/models/planner-models/planner-calendar-search.dto';
import { map, Observable } from 'rxjs';
import { DomainService } from '../domain.service';

@Injectable({
  providedIn: 'root'
})
export class CalendarNativeService {
  private _apiUrl: string = '';

  constructor(private readonly http: HttpClient,
    private _domainService: DomainService,
  ) {
    // subscribe to object registered in related service
    this._domainService.apiUrl$.subscribe((apiUrl: string) => {
      this._apiUrl = apiUrl;
    });
  }

  getObjectEvents(searchParams: PlanerCalendarSearchDto): Observable<EventDto[]> {
    return this.http.post<{ Events: EventDto[] }>(`${this._apiUrl}planner/calendar`, searchParams)

      .pipe(map(respose => respose.Events), map(scheduleList => scheduleList.map(scheduleAbsence => ({
        ...scheduleAbsence,
        EventDate: new Date(scheduleAbsence.EventDate),
        NextEventDate: new Date(scheduleAbsence.NextEventDate)
      }))));
  }
}
